import { Controller } from '@hotwired/stimulus'
import { toggle } from 'el-transition'
import URI from 'urijs'

export default class extends Controller {
  static targets = ['filter']

  static values = {
    turboFrame: String,
    dynamicFiltersComponentId: String,
  }

  get paramKey() {
    return window.Avo.configuration.avo_filters.param_key
  }

  get inTurboFrame() {
    return true
  }

  apply() {
    requestAnimationFrame(() => {
      this.triggerRequest()
    })
  }

  // The triggerRequest method should take into account if this controller is being rendered on the root Index page (/resources/users) or in an association frame.
  // If it's rendered in a frame we should compose the filtered URL from the frame URL, if not, from the current page URL.
  triggerRequest() {
    let url
    if (this.turboFrameValue) {
      // go and find that frame's URL
      url = new URI(document.querySelector(`turbo-frame#${this.turboFrameValue}`).src)
    } else {
      url = new URI()
    }

    // Send the filters like so
    // ?filters[first_name][is][]=11&filters[first_name][is][]=22&filters[first_name][is_not][]=22&filters[last_name][is_not][]=22
    // That gives us a hash like so
    // {"filters"=>{"first_name"=>{"is"=>["11", "22"], "is_not"=>["22"]}, "last_name"=>{"is_not"=>["22"]}}, "controller"=>"avo/projects", "action"=>"index"}
    // the "is" attirubte is an array so we can add multiple conditions on the same predicate
    // Ex: first_name.not.empty && first_name.not_in.a

    url.removeSearch(new RegExp(`${this.paramKey}`))

    // Remove the page param so pagination is reset when filters are applied
    url.removeSearch('page')

    // traverse all the filters
    this.filterTargets.forEach((el) => {
      const id = el.dataset.filterParamId
      const condition = el.querySelector("[data-control='condition']").value
      let { value } = el.querySelector("[data-control='value']")

      if (el.dataset.fieldType === 'number' && condition === 'is_within') {
        const value2 = el.querySelector("[data-control='value_2']").value

        value = `${value} to ${value2}`
      }

      // compose the url params with the conditions and values
      url.setSearch(`${this.paramKey}[${id}][${condition}][]=${encodeURIComponent(value)}`)
    })

    // Transpose them to a URL
    const finalUrl = url.readable().toString()

    // Initiate a visit
    // This is being done different depending if the filters are rendered in a frame or on the root level.
    if (this.turboFrameValue) {
      document.querySelector(`turbo-frame#${this.turboFrameValue}`).src = finalUrl
    } else {
      window.Turbo.visit(finalUrl)
    }
  }

  toggleFilter() {
    this.containerTarget.classList.toggle('hidden')
  }

  // Simulate the target because we're going to toggle an element that's ouside the controller container
  get containerTarget() {
    return document.getElementById(this.dynamicFiltersComponentIdValue)
  }

  async toggleFiltersArea() {
    if (this.containerTarget) {
      await toggle(this.containerTarget)
      const isOpen = !this.containerTarget.classList.contains('hidden')

      if (isOpen) {
        document.querySelector(
          `#${this.dynamicFiltersComponentIdValue} [data-avo-filters-target="add-filter-button"]`,
        ).click()
      }
    }
  }

  removeFilter(e) {
    e.target.closest("[data-avo-filters-target='filter']").remove()
    this.apply()
  }

  resetFilters() {
    const url = new URI()
    url.removeSearch(new RegExp(`${this.paramKey}`))
    window.Turbo.visit(url.readable().toString())
  }
}
